import { useQuery, useMutation } from "@tanstack/react-query";
import { GET } from "../../../../services/index";

// รายงานการเข้า-ออกงาน (ต่อพนักงาน ต่อวัน)
export const useFetchAttendanceReport = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, userId, jobType, shift }) => {
      const params = new URLSearchParams({ startDate, endDate });
      if (userId) params.append("userId", userId);
      if (jobType) params.append("jobType", jobType);
      if (shift) params.append("shift", shift);
      return await GET(`/api/v1/timeclock/report?${params.toString()}`);
    },
  });
};

// รายชื่อพนักงาน (role 3) สำหรับ dropdown filter
export const useFetchEmployeeOptions = () => {
  const companyId = sessionStorage.getItem("activeCompanyId");
  return useQuery(
    ["attendanceEmployeeOptions", companyId],
    async () => {
      const { result } = await GET(`/api/v1/users/list/${companyId}`);
      return (result || []).map((u) => ({ value: String(u.id), label: u.UserName }));
    },
    { enabled: !!companyId }
  );
};
